const Path = () => {
  return (
    <svg width="14" height="8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity=".4"
        d="m6.67 5.255 4.95-4.95a1 1 0 1 1 1.413 1.414L7.376 7.376a1 1 0 0 1-1.414 0L.305 1.72A1 1 0 1 1 1.72.305l4.95 4.95Z"
        fill="#fff"
      />
    </svg>
  );
};
export default Path;
